import { render, staticRenderFns } from "./IABFCorpsPieces.vue?vue&type=template&id=59ac4c15&scoped=true"
import script from "./IABFCorpsPieces.vue?vue&type=script&lang=js"
export * from "./IABFCorpsPieces.vue?vue&type=script&lang=js"
import style0 from "./IABFCorpsPieces.vue?vue&type=style&index=0&id=59ac4c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac4c15",
  null
  
)

export default component.exports